export async function resolveBusinessTemplateContextResult<T>(
  isCurrent: () => boolean,
  action: () => Promise<T>
): Promise<T | null> {
  try {
    const result = await action()
    return isCurrent() ? result : null
  } catch (error) {
    if (isCurrent()) throw error
    return null
  }
}
